import React, { useCallback, useEffect, useState } from "react";

// https://dev.to/jmalvarez/check-if-an-element-is-visible-with-react-hooks-27h8
export default function useVisibility(): { isInViewport: boolean; ref: any } {
    const [isInViewport, setIsInViewport] = useState(false);
    const [refElement, setRefElement] = useState<HTMLElement | null>(null);

    const setRef = useCallback((node: HTMLElement | null) => {
        if (node !== null) {
            setRefElement(node);
        }
    }, []);

    useEffect(() => {
        if (refElement && !isInViewport) {
            const observer = new IntersectionObserver(([entry]) => entry.isIntersecting && setIsInViewport(true));
            observer.observe(refElement);

            return () => {
                observer.disconnect();
            };
        }
    }, [isInViewport, refElement]);

    return { isInViewport, ref: setRef };
}
